import React from 'react';
import { Helmet } from 'react-helmet';

type FaqItem = {
  Header?: string | null;
  Content?: string | null;
};

type Props = {
  items: FaqItem[];
};

function stripRichTextForSchema(text: string): string {
  return text
    .replace(/<[^>]*>/g, ' ')
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/(\*\*|__)(.*?)\1/g, '$2')
    .replace(/(\*|_)(.*?)\1/g, '$2')
    .replace(/`{1,3}([^`]*)`{1,3}/g, '$1')
    .replace(/\s+/g, ' ')
    .trim();
}

export const FaqSchema: React.FC<Props> = ({ items }) => {
  const mainEntity = items
    .filter(
      (item): item is { Header: string; Content: string } =>
        !!item.Header?.trim() && !!item.Content?.trim()
    )
    .map(({ Header, Content }) => ({
      '@type': 'Question',
      name: Header.trim(),
      acceptedAnswer: {
        '@type': 'Answer',
        text: stripRichTextForSchema(Content),
      },
    }));

  if (mainEntity.length === 0) {
    return null;
  }

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity,
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default FaqSchema;
